import { SandGrid } from './sandgrid/SandGrid';
import { WaterGrid } from './water/WaterGrid';
import { WetSandTracker } from './WetSandTracker';
import { FoamParticleSystem } from './particles/FoamParticleSystem';
import { DustParticleSystem } from './particles/DustParticleSystem';

export class World {
  public readonly sandGrid: SandGrid;
  public readonly waterGrid: WaterGrid;
  public readonly wetSandTracker: WetSandTracker;
  public readonly foamParticles: FoamParticleSystem;
  public readonly dustParticles: DustParticleSystem;
  public readonly width: number;
  public readonly height: number;

  constructor(width: number, height: number, initialSandHeight: number = 0) {
    this.width = width;
    this.height = height;
    this.sandGrid = new SandGrid(width, height, initialSandHeight);
    this.waterGrid = new WaterGrid(width, height);
    this.wetSandTracker = new WetSandTracker(width, height);
    this.foamParticles = new FoamParticleSystem();
    this.dustParticles = new DustParticleSystem();
  }

  public clear(): void {
    this.waterGrid.clear();
    this.wetSandTracker.clear();
    this.foamParticles.clear();
    this.dustParticles.clear();
  }

  public reset(initialSandHeight: number): void {
    this.sandGrid.fill(initialSandHeight);
    this.waterGrid.clear();
    this.wetSandTracker.clear();
    this.foamParticles.clear();
    this.dustParticles.clear();
  }
}
